/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import GoogleMapReact from 'google-map-react';
import { Row, Col, Typography } from 'antd';
import {
  selectCompanyProfile, selectProfileLoading, selectCompanyDetailFlurry, selectCompanyDetailsCall,
} from 'Selector/CompaniesSelector';
import { backgroundColorParsing, valueToObject } from 'Utils/UtilityFunctions';
import { actions as flurryActions } from 'Slice/HelperSlice';
import { actions as companiesActions } from 'Slice/CompaniesSlice';
import { GOOGLE_MAP_KEY } from 'Utils/Constants';
import Geocode from 'react-geocode';
import {
  GeocodeResponse,
} from 'Types/CompaniesTypes';
import { PeopleNotFound } from 'Pages/people/PeopleGroupDetail';
import FinancialStatsWidget from '../../common/components/FinancialStatsWidget';
import PeopleCardLarge from '../../common/components/PeopleCardLarge';
import FinancialStatsSkeleton from '../../common/skeleton/FinancialStatsSkeleton';
import PersonSkeleton from '../../common/skeleton/PersonSkeleton';
import {
  primaryColor, wMedium, wLight, primaryFont, secondaryFont, maxWidth, retina, primaryHeadingColor,
  wBold,
  tabHeading,
  maxTablet,
  maxMobile,
  midMobile,
} from '../../../Utils/utilsStyle';
import Ranking from './Ranking';
import { selectClusterCompanyProfile, selectClusterCompanyProfileLoading } from '../../../Selector/ClustersSelector';

const { Paragraph } = Typography;

const Wrapper = styled.div`
  .company-details-heading {
    ${tabHeading};
  }
  .company-description{
   margin: 50px 18px 40px 18px;
   @media all and (max-width: ${maxWidth}) , ${retina} {
   margin: 30px 0px 40px 0px;
   }
   div.ant-typography, .ant-typography p{
    margin:0px;
    color:#7E7E7E;
    font-weight:${wLight};
    font-family:${primaryFont};
    font-size:20px;
    white-space: pre-wrap;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: 14px;
    }
     .ant-typography-expand{
        color:${primaryColor};
      }
   }
  }
  .ceo-tile{
    background-color:#fff;
    box-shadow:0px 0px 24px rgb(0 0 0 / 10%);
    border-radius:8px;
    position: relative;
    height: 186px;
    margin-bottom: 21px;
    .label-name{
      position: absolute;
      left:26px;
      top:20px;
      color:#67696A;
      font-size:16px;
      font-weight:${wMedium};
      font-family:${primaryFont};
      @media all and (max-width: ${maxTablet}) {
        top: 10px;
        left: 10px;
      }
    }
    > div {
      margin: 0 auto;
      padding: 25px 0;
      .tag-p, .btn{
        display:none;
      }
    }
    .noResults {
      height: inherit;
    }
  }
  .year-tile{
    height:186px;
    background-color:#fff;
    border-radius:8px;
    box-shadow:0px 0px 24px rgb(0 0 0 / 10%);
    > div {
      /* padding:25px 0; */
      margin:0;
      width:100%;
      max-width: none;
      box-shadow:none;
    }
  }
  .map-tile{
    border-radius:8px;
    box-shadow:0px 0px 24px rgb(0 0 0 / 10%);
    overflow:hidden;
    height: 100%;
    .map-wrapper-top {
      height: 301px;
      width: 100%;
    }
    .map-address{
      background-color:#fff;
      border-radius:0 0 8px 8px;
      height: 92px;
      color:#424B50;
      font-size:17px;
      font-family:${secondaryFont};
      font-weight:${wBold};
      padding: 25px 20px;
      @media all and (max-width: ${maxTablet}) {
        padding: 8px 20px; 
        line-height: 18px;
      }
      @media all and (max-width: ${maxMobile}) {
        padding: 16px 10px;
        font-size: 14px;
      }
    }
    > {
      div {
        height: 100%;
      }
    }
  }
  .skeleton-map-wrapper {
    display: flex;
    flex-direction: column;
    .map-box{
      width:100%;
      height: 301px;
      border-radius: 0px;
    }
  }
  .description-box{
    width:100%;
    height:150px;
    border-radius:8px;
    margin:35px 0;
  }
  .description-line{
     width:75%;
    height:18px;
    border-radius:8px;
    margin:5px 0;
  }
  .c-pointer {
    .primary-color {
      margin-top: 30px;
    }
  }
  .ceo-tile {
    .image-wrap-placeholder {
      .person-image-holder {
        margin: 2px;
      }
    }
    .person-item-widget {
      &.isFromLargeCard {
        .name-wrapper {
              bottom: 0px;
          h4 {
            font-size: 12px;
            letter-spacing: -0.35;
            margin: 2px;
            padding-left: 10px;
            @media all and (max-width: ${maxWidth}) , ${retina} {
              font-size: 10px;
              margin: 3px;
            }
          }
          .anticon {
            min-width: 8px;
          }
          svg {
            width: 11px;
          }
        }
      }
    }
  }
  .ranking-years-wrapper, .ranking-years-wrapper-skeleton {
    @media all and (max-width: ${midMobile}) {
      margin-top: 16px;
    }
    .year-tile {
      &:nth-child(1){
        margin-bottom: 21px;
      }
    }
  }
  &.xs-res-layout {
    .first-col {
      @media all and (max-width: ${midMobile}) {
        flex: 0 0 100%;
        max-width: 100%;
        display: flex;
      }
      .nesting-tile {
        @media all and (max-width: ${midMobile}) {
          min-width: 48%;
          width: 48%;
        }
        &:nth-child(2) {
          @media all and (max-width: ${midMobile}) {
            margin-left: 16px;
          }
        }
      }
    }
  }
`;
type Props = {
  isCluster?: boolean
  companyId?: number
}

const defaultProps = {
  isCluster: false,
  companyId: 0,
}
const CompanyDetailsTab = function CompanyDetailsTab(props: Props) {
  const { isCluster, companyId } = props;
  const clusterCompanyProfile = useSelector(selectClusterCompanyProfile);
  const clusterCompanyProfileLoading = useSelector(selectClusterCompanyProfileLoading);
  const companyProfile = isCluster ? clusterCompanyProfile[companyId ?? 0] : useSelector(selectCompanyProfile);
  const companyProfileLoading = isCluster ? clusterCompanyProfileLoading[companyId ?? 0] : useSelector(selectProfileLoading);
  const dispatch = useDispatch();

  const flurryObject = useSelector(selectCompanyDetailFlurry);
  const isCalled = useSelector(selectCompanyDetailsCall);
  const [coordinates, setCoordinates] = useState({ isSet: false, xAxis: 0, yAxis: 0 });
  const companyProfileRankingList = companyProfile
    && companyProfile.companyFinancialInfo.status.toLowerCase() === 'public'
    && companyProfile?.ranking
    ? companyProfile?.ranking.length : 0;
  const { address } = companyProfile?.companyAddress || {};
  const layoutSet = companyProfileRankingList > 0 && (companyProfile?.companyCeo?.personId
    || (address && address.length)) ? 10 : 16;

  useEffect(() => {
    if (flurryObject) {
      dispatch(flurryActions.callFlurryEvent(
        valueToObject('company_detail', 0, {
          ...flurryObject,
          isDeleteTime: true,
          ...isCalled && { isCalled },
        }),
      ));
      dispatch(companiesActions.setCompanyDetailCall(true));
    }
  }, [flurryObject]);

  useEffect(() => {
    if (address
      && address.length > 0) {
      Geocode.setApiKey(GOOGLE_MAP_KEY);
      Geocode.fromAddress(address).then(
        (response: GeocodeResponse) => {
          const { lat, lng } = response.results[0].geometry.location;
          setCoordinates({ isSet: true, xAxis: lng, yAxis: lat });
        },
        (error) => {
          setCoordinates({ isSet: false, xAxis: 0, yAxis: 0 });
          console.error(error);
        },
      );
    }
  }, [companyProfile]);

  const ellipsis = true;
  return (
    <Wrapper className="xs-res-layout">
      <span className="company-details-heading">
        Details
      </span>
      <Row gutter={20}>
        {
          companyProfileLoading ? (
            <Col span={6} xs={12} sm={7} md={6} className="first-col">
              <div className="ceo-tile nesting-tile">
                <PersonSkeleton diameter="130px" diameterSm="120px" onlyPersonImage />
              </div>
              <div className="year-tile d-flex align-items-center nesting-tile">
                <FinancialStatsSkeleton />
              </div>
            </Col>
          ) : (
            companyProfile?.companyCeo?.personId || (address && address.length > 0) ? (
              <Col span={6} xs={12} sm={7} md={6} className="first-col">
                <div className="ceo-tile nesting-tile">
                  <span className="label-name">CEO</span>
                  {
                    companyProfile?.companyCeo?.personId ? (
                      <PeopleCardLarge
                        key={companyProfile?.companyCeo?.personId}
                        personId={companyProfile?.companyCeo?.personId}
                        persona={companyProfile?.companyCeo?.archeType?.color}
                        logo={companyProfile?.companyCeo?.personImage}
                        personName={companyProfile?.companyCeo?.personName}
                        tag={companyProfile?.companyCeo?.personDesignation}
                        personaType={companyProfile?.companyCeo?.archeType?.name}
                        wrapperColor={companyProfile?.companyCeo
                          && backgroundColorParsing(companyProfile?.companyCeo?.personalityTypes)}
                        hidePersonality={false}
                        personalityTypesColors={companyProfile?.companyCeo
                          && companyProfile?.companyCeo?.personalityTypes}
                        noFollow
                        isClassFromLargeCard
                        diameter="120px"
                        diameterSm="120px"
                        imageDiameter="120px"
                        holoDiameterHeight="106px"
                        holoDiameterWidth="115px"
                      />
                    ) : (
                      <div className="d-flex justify-content-center align-items-center noResults">
                        <PeopleNotFound>No Results Found</PeopleNotFound>
                      </div>
                    )
                  }
                </div>
                {address
                  && address.length > 0
                  && (
                    <div className="year-tile d-flex align-items-center nesting-tile">
                      <FinancialStatsWidget
                        colorText={primaryHeadingColor}
                        companyName="Founded"
                        title={companyProfile?.companyFounded}
                        sizeText="68px"
                        sizeTextSm="68px"
                      />
                    </div>
                  )}
              </Col>
            ) : null
          )
        }
        {address
          && address.length === 0
          && (
            <Col span={6} xs={24} sm={24}>
              <div className="year-tile d-flex align-items-center">
                <FinancialStatsWidget
                  colorText={primaryHeadingColor}
                  companyName="Founded"
                  title={companyProfile?.companyFounded}
                  sizeText="68px"
                  sizeTextSm="68px"
                />
              </div>
            </Col>
          )}
        {
          companyProfileLoading ? (
            <Col span={`${layoutSet}`} xs={24} sm={layoutSet}>
              <div className="map-tile skeleton-map-wrapper">
                <span className="skeleton-box map-box" />
                <div className="map-address">
                  <span className="skeleton-box description-line" />
                  <span className="skeleton-box description-line" />
                </div>
              </div>
            </Col>
          ) : (address
            && address.length > 0
            && (
              <Col span={`${layoutSet}`} xs={24} sm={layoutSet}>
                <div className="map-tile">
                  {coordinates.isSet && (
                    <div className="map-wrapper-top">
                      <GoogleMapReact
                        bootstrapURLKeys={{ key: GOOGLE_MAP_KEY }}
                        center={{
                          lng: coordinates.xAxis,
                          lat: coordinates.yAxis,
                        }}
                        defaultZoom={15}
                        /*eslint-disable */
                        onGoogleApiLoaded={({ map, maps }) => {
                          const marker = new maps.Marker({
                            position: {
                              lng: coordinates.xAxis,
                              lat: coordinates.yAxis,
                            },
                            map,
                            title: address.length ? address : '',
                          });
                          return marker;
                        }}
                      />
                    </div>
                  )}
                  <div className="map-address">
                    {address.length ? address : ''}
                  </div>
                </div>
              </Col>
            )
          )
        }
        {
          companyProfileLoading ? (
            <>
              <Col span={6} xs={12} sm={6} className="ranking-years-wrapper-skeleton">
                <div className="year-tile d-flex align-items-center">
                  <FinancialStatsSkeleton />
                </div>
                <div className="year-tile d-flex align-items-center">
                  <FinancialStatsSkeleton />
                </div>
              </Col>

            </>
          )
            : companyProfileRankingList > 0 ? <>
              <Col span={6} xs={12} sm={7} className="ranking-years-wrapper">
                {
                  companyProfile?.ranking?.slice(0, 2).map((item) => (
                    <div className="year-tile d-flex align-items-center">
                      <Ranking
                        colorText={primaryHeadingColor}
                        rankItem={item}
                        sizeText="68px"
                        sizeTextSm="68px"
                      />
                    </div>
                  ))
                }
              </Col>
            </> : null
        }
        {
          companyProfileLoading ? (
            <Col span={24}><span className="skeleton-box description-box" /></Col>
          ) : (
            <Col span={24}>
              <div className="company-description">
                <Paragraph
                  ellipsis={ellipsis ? { rows: 7, expandable: true, symbol: 'more' } : false}
                >
                  {companyProfile?.description?.length ? companyProfile.description : 'N/A'}
                </Paragraph>
              </div>
            </Col>
          )
        }
      </Row>
    </Wrapper >
  );
};

export default React.memo(CompanyDetailsTab);
